export default {
  link: '',
  previewSrc: 'futures.png',
  title: 'Журнал «Идеология будущего»',
  announce:
    'Общественно-политический, научно-теоретический, экспертно-аналитический журнал',
  model_type: 'specialprojectsection',
  type: 'third',
  gallery: [
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part19.png',
      label: 'Выпуск 19',
      link: '/files/ideology_of_future_19.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part18.png',
      label: 'Выпуск 18',
      link: '/files/ideology_of_future_18.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part17.png',
      label: 'Выпуск 17',
      link: '/files/ideology_of_future_17.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part16.png',
      label: 'Выпуск 16',
      link: '/files/ideology_of_future_16.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part15.png',
      label: 'Выпуск 15',
      link: '/files/ideology_of_future_15.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part14.jpg',
      label: 'Выпуск 14',
      link: '/files/ideology_of_future_14_v2.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part13.png',
      label: 'Выпуск 13',
      link: '/files/ideology_of_future_13_v2.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part12.png',
      label: 'Выпуск 12',
      link: '/files/ideology_of_future_12_v2.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part11.png',
      label: 'Выпуск 11',
      link: '/files/ideology_of_future_11_v2.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part10.jpg',
      label: 'Выпуск 10',
      link: '/files/ideology_of_future_10.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part9.jpg',
      label: 'Выпуск 9',
      link: '/files/ideology_of_future_9_v2.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part8.jpg',
      label: 'Выпуск 8',
      link: '/files/ideology_of_future_8_v2.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part7.jpg',
      label: 'Выпуск 7',
      link: '/images/RVIO_7_2022.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part6.jpg',
      label: 'Выпуск 6',
      link: '/files/ideology_of_future_6.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part5.jpeg',
      label: 'Выпуск 5',
      link: '/files/ideology_of_future_part5.pdf',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'future-idiology.png',
      label: 'Выпуск 4',
      link: '/magazine/release/ideologiya-budushchego-obshchestvenno-politicheskiy-nauchno-teoreticheskiy-ekspertno-analiticheskiy-zhurnal-2021-4',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part3.png',
      label: 'Выпуск 3',
      link: '/magazine/release/ideologiya-budushchego-obshchestvenno-politicheskiy-nauchno-teoreticheskiy-ekspertno-analiticheskiy-zhurnal-2021-3',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'ideology_of_future_part2.jpeg',
      label: 'Выпуск 2',
      link: '/magazine/release/ideologiya-budushchego-obshchestvenno-politicheskiy-nauchno-teoreticheskiy-ekspertno-analiticheskiy-zhurnal-2021-2',
      title: '',
    },
    {
      static: 'other',
      previewSrc: 'future-idiology.png',
      label: 'Выпуск 1',
      link: '/magazine/release/ideologiya-budushchego-obshchestvenno-politicheskiy-nauchno-teoreticheskiy-ekspertno-analiticheskiy-zhurnal-2021-1',
      title: '',
    },
  ],
};
